import React from 'react';

export const AlertIcon = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--alert';
  color = color || '#B30000';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...{ className }}
    >
      <g clipPath="url(#clip0_4837_4905)">
        <path
          d="M9.99999 11.3333H2.66666C3.02995 11.1276 3.33986 10.8395 3.57145 10.4921C3.80303 10.1447 3.94982 9.7478 3.99999 9.33333V7.33333C4.0397 6.48738 4.30886 5.66818 4.77862 4.96353C5.24839 4.25888 5.90105 3.69535 6.66666 3.33333C6.66666 2.97971 6.80713 2.64057 7.05718 2.39052C7.30723 2.14048 7.64637 2 7.99999 2C8.35361 2 8.69275 2.14048 8.9428 2.39052C9.19285 2.64057 9.33332 2.97971 9.33332 3.33333C10.0989 3.69535 10.7516 4.25888 11.2214 4.96353C11.6911 5.66818 11.9603 6.48738 12 7.33333V8.33333"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 11.3333V12C6 12.5304 6.21071 13.0391 6.58579 13.4142C6.96086 13.7893 7.46957 14 8 14C8.53043 14 9.03914 13.7893 9.41421 13.4142C9.78929 13.0391 10 12.5304 10 12V11.3333"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6667 10.6667V12.6667"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6667 14.6667V14.6733"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4837_4905">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertIcon;
